const uris = {
  apiBase: process.env.REACT_APP_API_BASE,
  event: 'event',
  page: 'page'
}

export default uris
